import { adminHome, isStaff, type Permission } from "./permissions";

/** Landing path for a signed-in user, from the role they hold in the active club. */
export function roleHome(user: { roles?: string[]; isSuperAdmin?: boolean; impersonator?: string | null; children?: unknown[]; pendingChildren?: number; permissions?: Permission[]; isStaff?: boolean }): string | null {
  if (user.isSuperAdmin && !user.impersonator && !user.roles?.some((r) => r !== 'ROLE_USER' && r !== 'ROLE_SUPER_ADMIN')) return "/super-admin";
  const admin = adminHome(user);
  if (admin) return admin;
  if (isStaff(user)) return "/coach";
  if (user.roles?.includes('ROLE_STUDENT')) return "/student";
  // A parent with no club role of their own picks which child to open (or confirms one first).
  if ((user.children?.length || user.pendingChildren) && !user.impersonator) return "/choose-profile";
  // No role in any active club (left it, or the club is gone): the history still belongs to them.
  return "/historique";
}
